import type { ReactNode, FC } from "react";

import styled from "styled-components";

import { setFont } from "@similarweb/styles";

import { cpcFilter } from "app/filters/ngFilters";

import { DefaultCell } from "./DefaultCell";

const StyledCell = styled(DefaultCell)`
    ${setFont({ $family: "'Roboto'" })};
    text-align: right;
    justify-content: flex-end;
`;

export const CPCCell: FC<{
    value?: number;
    children?: ReactNode;
    className?: string;
}> = ({ value, children, className }) => {
    return <StyledCell className={className}>{children || cpcFilter()(value)}</StyledCell>;
};
